import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { TemplateCornSchema } from '@eigtech/templates-types';
import { z } from 'zod';
import { DraftDocumentRecordSchema } from '../base/draftDocument.js';
export const GetDraftDocumentPathSchema = z.object({
    entityId: ClaimV2CornSchema,
    templateId: TemplateCornSchema,
});
export const GetDraftDocumentResponseSchema = z.object({
    draftDocument: DraftDocumentRecordSchema,
    documentUrl: z.string().optional(),
});
export const GetDraftDocumentRequestSchema = GetDraftDocumentPathSchema;
export const GetDraftDocumentApiSchema = {
    params: GetDraftDocumentPathSchema,
    response: GetDraftDocumentResponseSchema,
};
